import { createContext } from 'react';

import type { AckArgsWithoutAck, AckEvents, AckReturnData, ClientToServerEvents, NonAckArgs, NonAckEvents } from '@game/shared-types';

type SendToServer = <Event extends NonAckEvents<ClientToServerEvents>>(event: Event, ...args: NonAckArgs<ClientToServerEvents, Event>) => void;

export type SendToServerPromise = <Event extends AckEvents<ClientToServerEvents>>(
  event: Event,
  ...args: AckArgsWithoutAck<ClientToServerEvents, Event>
) => Promise<AckReturnData<ClientToServerEvents, Event>>;

export const SocketContext = createContext<
  | {
      sendToServer: SendToServer;
      sendToServerPromise: SendToServerPromise;
    }
  | undefined
>(undefined);
